module.exports = __webpack_public_path__ + "img/462.f4fd9428.jpg";